export default __webpack_public_path__ + "static/media/uploader-relion-4.1362a777.png";